import useSWR from "swr";
import { useContext, useEffect } from "react";
import { Context, Menu } from "../../context";
import { fetcher } from "../../utils/fetcher";
import { VRSTA_OPERATERA } from "../../enums";

const useIndex = (methods: any) => {
  const [data, setData] = useContext(Context);
  const { token } = data;

  const { data: operaterPlatforme } = useSWR(
    `${process.env.REACT_APP_API_URL}/operateri`,
    (url: string) =>
      fetcher(url, { headers: { Authorization: `Bearer ${token}` } })
  );
  const { data: drzave } = useSWR(
    `${process.env.REACT_APP_API_URL}/sifrarnici/drzave`,
    fetcher
  );
  const { data: elektronickeAdrese } = useSWR(
    `${process.env.REACT_APP_API_URL}/sifrarnici/elektronicke-adrese`,
    fetcher
  );
  const { data: identifikatori } = useSWR(
    `${process.env.REACT_APP_API_URL}/sifrarnici/identifikatori`,
    fetcher
  );

  useEffect(() => {
    if (drzave && elektronickeAdrese && identifikatori && operaterPlatforme) {
      methods.reset((formValues: any) => ({
        ...formValues,
        ...operaterPlatforme,
        operaterPlatforme: operaterPlatforme.operaterPlatformeModel,
        drzave,
        elektronickeAdrese,
        identifikatori,
        loading: false,
      }));
      setData({
        ...data,
        menu: data.menu.map((item: Menu) => ({
          ...item,
          hidden:
            item.id === "oslobodjenje" &&
            operaterPlatforme.operaterPlatformeModel.vrstaOperatera.id ===
              VRSTA_OPERATERA.IZVAN_EU,
        })),
      });
    }
  }, [drzave, elektronickeAdrese, identifikatori, operaterPlatforme]);

  return {
    operaterPlatforme: operaterPlatforme
      ? operaterPlatforme.operaterPlatformeModel
      : {},
    drzave,
    elektronickeAdrese: elektronickeAdrese
      ? elektronickeAdrese.filter((adresa: any) => adresa.id !== 1)
      : [],
    identifikatori,
  };
};

export default useIndex;
